"use client";

import * as React from "react";
import { AppPageLayoutV2 } from "../layout/AppPageLayoutV2";

export interface HomePageLayoutV2Props {
  children: React.ReactNode;
  contentPadding?: "default" | "none";
}

export function HomePageLayoutV2({
  children,
  contentPadding = "default"
}: HomePageLayoutV2Props) {
  return (
    <AppPageLayoutV2 contentPadding={contentPadding}>
      {children}
    </AppPageLayoutV2>
  );
}
